export default __webpack_public_path__ + "static/media/left.943b298e.svg";